


































































import {Component, Vue, Prop} from 'vue-property-decorator';
import {requiredRule, emailRules} from '../../../helpers/rules-validator';
import Client, {ClientStatus} from '../../../data/models/client';

@Component({})
export default class CreateUpdateClient extends Vue {

  @Prop({required: true, default: false})
  opened: boolean;

  @Prop({required: true})
  form: Client;

  isFormValid = false;

  get statusItems(): any[] {
    return Object.values(ClientStatus).map((item) => {
      return {'text': this.$t(`clientStatus.${item}`), 'value': item};
    });
  }

  get dialog(): boolean {
    return this.opened;
  }

  set dialog(value: boolean) {
    this.$emit('close', value);
  }

  get isCreated(): boolean {
    return this.form.id == null;
  }

  get emailRules(): any {
    return emailRules(this.$t('rules.email.empty').toString(), this.$t('rules.email.format').toString());
  }

  get phoneRules(): any {
    return emailRules(this.$t('rules.phone.empty').toString(), this.$t('rules.phone.format').toString());
  }

  get requiredRule(): any {
    return requiredRule(this.$t('rules.required.empty').toString());
  }

  handleClick(): void {
    if (this.isCreated) {
      this.createClient();
    } else {
      this.updateClient();
    }
  }

  createClient(): void {
    this.$store.commit("showLoader", true);
    this.$dao.clients.create(this.form.toJSON()).then((result) => {
      if (result != null) {
        this.dialog = false;
      } else {
        throw 'err';
      }
    }).catch(() => {
      this.$dialog.error({text: this.$t('errors.createUser').toString(), title: this.$t('errors.error').toString(), actions: ['Fermer']});
    }).finally(() => this.$store.commit("showLoader", false));
  }

  updateClient(): void {
    this.$store.commit("showLoader", true);
    this.$dao.clients.update(this.form.id, this.form.toJSON()).then((result) => {
      if (result != null) {
        this.dialog = false;
      } else {
        throw 'err';
      }
    }).catch(() => {
      this.$dialog.error({text: this.$t('errors.updateUser').toString(), title: this.$t('errors.error').toString(), actions: ['Fermer']});
    }).finally(() => this.$store.commit("showLoader", false));
  }
}
